<template>
  <header>
    <div class="container-fluid header-container">
      <div>
        <div class="row m-0 align-items-center header-container-height float-left">
          <a href="/home"><img :src="ImgKraudLogo" class="header-desktop" height="40" alt="" /></a>
          <img :src="Group2" class="header-mobile" style="cursor: pointer;" height="40" alt="" />
        </div>
        <div class="row m-0 align-items-center header-container-height float-right">
          <div class="header-mobile">
            <div class="row m-0 align-items-center" style="width: 180px;">
              <div v-show="!isAuth"  class="header-login mr-5"><a  :class="isLogin ? 'text-header-select' : 'text-green'" href="/login">Log in</a></div>
              <div v-show="isAuth"  class="header-login mr-5"><a  :class="isLogin ? 'text-header-select' : 'text-green'" v-on:click='closeSession()' >Log out</a></div>
              <img :src="!setShow ? IcnMenu : IcnClose" @click="setShow ? setChangeValue (false) : setChangeValue(true)" class="header-mobile" style="cursor: pointer;" width="42" alt="">
            </div>
          </div>
          <div id="menuShow" class="header-container-info">
            <ul class="row m-0 header-back-ul">
              <li v-show="isAuth" :class="isHome ? 'header-select' : ''"><a  :class="isHome ? 'text-header-select' : 'text-green'" href="/">Inicio</a></li>
              <li v-show="!isAuth" :class="isWhoWeAre ? 'header-select' : ''"><a  :class="isWhoWeAre ? 'text-header-select' : 'text-green'" href="/">Quiénes Somos</a></li>
              <li v-show="isAuth" :class="isMarketplace ? 'header-select' : ''"><a  :class="isMarketplace ? 'text-header-select' : 'text-green'" href="/marketplace">Propiedades</a></li>
              <li :class="isBlog ? 'header-select' : ''"><a  :class="isBlog ? 'text-header-select' : 'text-green'" href="/blog">Blog</a></li>
              <li v-show="!isAuth" :class="isLogin ? ' header-desktop header-select' : 'header-desktop'"><a  :class="isLogin ? 'text-header-select' : 'text-green'" href="/login">Iniciar sesión</a></li>
              <li v-show="isAuth" :class="isLogin ? ' header-desktop header-select' : 'header-desktop'"><a  :class="isLogin ? 'text-header-select' : 'text-green'" v-on:click='closeSession()' >Cerrar sesión</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<style>
  .invisible {
    visibility: hidden;
  }
</style>
<script>
import HomeLayout from '@/layouts/HomeLayout'
import ImgKraudLogo from '@/assets/header/logo_kraud.svg'
import Group2 from '@/assets/header/Group2.png'
import IcnMenu from '@/assets/header/Icn_Menu.png'
import IcnClose from '@/assets/header/icn_close.png'
import {getId} from '@/services/returnVal'

export default {
  name: 'HeaderInfo',
  props: {
    section: {
      type: Boolean,
      required: false,
      default:true
    },
    isWhoWeAre: {
      type: Boolean,
      required: false,
      default:false
    },
    isMarketplace: {
      type: Boolean,
      required: false,
      default:false
    },
    isBlog: {
      type: Boolean,
      required: false,
      default:false
    },
    isLogin: {
      type: Boolean,
      required: false,
      default:false
    },
    isHome: {
      type: Boolean,
      required: false,
      default:false
    }
  },
  data () {
    return {
      ImgKraudLogo: ImgKraudLogo,
      Group2: Group2,
      IcnMenu: IcnMenu,
      IcnClose: IcnClose,
      setShow: true,
      windowWidth: window.innerWidth,
      isAuth: this.$session.exists()
    }
  },
  methods: {
    closeSession () {
      this.$session.destroy()
      this.$router.go({
        path: "/login"
    })
    },
    setChangeValue (value) {
      this.setShow = value
      if (value) {
        getId('menuShow').style.display = 'block'
        document.getElementById('menuShow').style.display = 'block'
      } else {
        getId('menuShow').style.display = 'none'
      }
    },
    resizeEventHandler(e) {
    if (window.innerWidth < 951) {
        console.log("Entro con seShot",this.setShow )
        this.setShow = false
        this.setChangeValue (false)
        getId('menuShow').style.display = 'none'
        document.getElementById('menuShow').style.display = 'none'
    }
  }
  },
  created () {
    //window.addEventListener("resize", this.resizeEventHandler);
  },
  mounted () {
    if (window.screen.width < 951) {
        this.setShow = false
        this.setChangeValue (false)
        getId('menuShow').style.display = 'none'
        document.getElementById('menuShow').style.display = 'none'
    }

    window.onresize = () => {
      if (window.innerWidth < 951) {
          this.setShow = false
          this.setChangeValue (false)
          getId('menuShow').style.display = 'none'
          document.getElementById('menuShow').style.display = 'none'
      }
      else {
        this.setChangeValue (false)
        getId('menuShow').style.display = 'block'
      }
    }
  },
  components: {
    HomeLayout
  }
}
</script>
